module.exports = __webpack_public_path__ + "static/media/06A.34c81337.png";